import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "../../../../../common/StyledToolTip";
import { ToggleRenderer } from '@dataGrid/components/cellRenderer';
import { RMAXLogger } from "../../../../../../services/LoggerService/RMAXLogger";
import Events from "../../../../../../utilities/EventEmitter";
const styles = (theme) => ({
  toggleAnimationButtonDispatchMap: {
    float: "right",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    height: "19px",
    [theme.breakpoints.down("md")]: {
      padding: "3px 8px",
    },
  },
  toggleText: {
    display: "inline-block",
    fontSize: "12px",
    color: theme.iconColor,
  },
});
const toggleAutoZoom = ({ isEnabled, toggleRouteAnimation }) => {
  Events.emit("routeAnimationPopup", !isEnabled);
  const eventSpecificData = {
    autoZoomEnabled: !isEnabled,
  };
  RMAXLogger.info("AutoZoom", eventSpecificData);
  toggleRouteAnimation && toggleRouteAnimation(!isEnabled);
};
const MapAutoZoom = ({ classes, ...props }) => {
  const label = `${props.isEnabled ? "Disable" : "Enable"} Auto Zoom`;
  return (
    <Tooltip title="Enable/Disable Route Animation">
      <div
        className={`${classes.toggleAnimationButtonDispatchMap} glHeaderIcons`}
      >
        <div className={classes.toggleText}>{label}</div>
        <ToggleRenderer
          value={props.isEnabled}
          onChange={() => toggleAutoZoom(props)}
        />
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(MapAutoZoom);
